import { Component, Input, inject } from '@angular/core';
import { Patient } from 'app/core/models/patient.model';
import { PatientService } from 'app/core/services/patient.service';
import { DatePipe } from '@angular/common';
import { SensitiveStringComponent } from '../../../shared/components/sensitive-string/sensitive-string.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { GenderPipe } from '../../../shared/pipes/gender.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-patient-demographics',
    templateUrl: './patient-demographics.component.html',
    styleUrls: ['./patient-demographics.component.scss'],
    imports: [SensitiveStringComponent, PhoneNumberComponent, DatePipe, GenderPipe, BlankValueDashPipe]
})
export class PatientDemographicsComponent {
  private patientService = inject(PatientService);

  @Input() patient: Patient;

  public onSsnAccessed(id: number): void {
    this.patientService.getSsn(id).subscribe(result => {
      if (this.patient.id === id) {
        this.patient.decryptedSsn = result.decryptedSsn;
      } else {
        const sub = this.patient.subPatients.find(subPatient => subPatient.id === id);
        if (sub) sub.decryptedSsn = result.decryptedSsn;
      }
    });
  }
}
